module.exports = __webpack_public_path__ + "static/media/line-small.65bc8d7b.svg";